document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const mobileMenuToggles = document.querySelectorAll('.menu-toggle');
    const menuOverlay = document.querySelector('.menu-overlay');
    let prevScrollPos = window.pageYOffset;

    // Menu panel: hovering a parent (or tapping on mobile) shows its children in the second column
    const mobileMenuParents = document.querySelectorAll('[data-mobile-menu-target]');
    const mobileMenuSubs = document.querySelectorAll('[data-mobile-menu-sub]');
    const mobileMenuCloseLinks = document.querySelectorAll('[data-mobile-menu-close]');
    const isMobile = window.matchMedia('(max-width: 500px)');
    const canHover = window.matchMedia('(hover: hover)');

    function showMobileMenuSub(target) {
        mobileMenuSubs.forEach(sub => {
            sub.classList.toggle('show-menu', sub.getAttribute('data-mobile-menu-sub') === target);
        });
    }

    mobileMenuParents.forEach(parent => {
        const target = parent.getAttribute('data-mobile-menu-target');
        const href = parent.getAttribute('href');

        // Hover to preview only on mouse/trackpad, so touch devices act on the first tap
        if (canHover.matches) {
            parent.addEventListener('mouseenter', () => showMobileMenuSub(target));
        }
        parent.addEventListener('click', function(e) {
            // Phones and touch devices: tap shows the children instead of following the link
            if (isMobile.matches || !canHover.matches || !href || href === '#') {
                e.preventDefault();
                showMobileMenuSub(target);
            }
        });
    });

    mobileMenuCloseLinks.forEach(link => {
        if (canHover.matches) {
            link.addEventListener('mouseenter', () => showMobileMenuSub(null));
        }
    });

    // Mobile menu open/close functionality
    if (mobileMenuToggles.length) {
        mobileMenuToggles.forEach(function(toggle) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                document.body.classList.toggle('mobile-menu-open');
            });
        });
    }

    function checkScroll() {
      if (!header) return;
      const currentScrollPos = window.pageYOffset;
      const scrollDifference = prevScrollPos - currentScrollPos;
      
      // Check if we're at the bottom of the page
      const documentHeight = Math.max(
        document.body.scrollHeight, 
        document.body.offsetHeight, 
        document.documentElement.clientHeight, 
        document.documentElement.scrollHeight, 
        document.documentElement.offsetHeight
      );
      const windowHeight = window.innerHeight;
      const isAtBottom = (currentScrollPos + windowHeight) >= (documentHeight - 10); // 10px buffer

      // Add sticky class when scrolling up more than 10px and past 40px, but NOT when at bottom or within 40px of top
      if (scrollDifference > 10 && currentScrollPos > 40 && !isAtBottom) {
        document.body.classList.add('header-sticky');
      } else if (scrollDifference < -2 || isAtBottom || currentScrollPos <= 40) {
        // Remove when scrolling down more than 10px OR when at bottom OR within 40px of top
        document.body.classList.remove('header-sticky');
      }

      prevScrollPos = currentScrollPos;
    }

    window.addEventListener('scroll', checkScroll);
    checkScroll();

    const headerItems = document.querySelectorAll('.header-item');
    const headerToggleItems = document.querySelectorAll('.header-item--toggle');
    const headerSectionMenu = document.querySelector('.header-section--menu');

    // Calculate and set menu background heights to the tallest menu
    function calculateMenuHeights() {
      let maxHeight = 0;
      
      // Find the tallest menu across all toggle items
      headerToggleItems.forEach(toggleItem => {
        const menu = toggleItem.querySelector('.header-item-menu');
        if (menu) {
          const menuHeight = menu.offsetHeight;
          if (menuHeight > maxHeight) {
            maxHeight = menuHeight;
          }
        }
      });
      
      const totalHeight = maxHeight;
      
      // Set the menu background to the maximum height
      const menuBackground = headerSectionMenu?.querySelector('.header-item-menu-background');
      
      if (menuBackground) {
        menuBackground.style.height = totalHeight + 'px';
        menuBackground.style.marginTop = '-' + totalHeight + 'px';
        menuBackground.style.setProperty('--translate-distance', totalHeight + 'px');
      }
    }

    // Call on load
    calculateMenuHeights();
    
    // Recalculate on window resize
    window.addEventListener('resize', calculateMenuHeights);

    function updateMenuOpenClass() {
      if (!headerSectionMenu) return;
      const anyActive = Array.from(headerToggleItems).some(i => i.classList.contains('active'));
      if (anyActive) {
        headerSectionMenu.classList.add('header-section--menu-open');
        document.body.classList.add('menu-open');
        
        // Add the no-delay class after the initial animation
        setTimeout(() => {
          if (headerSectionMenu.classList.contains('header-section--menu-open')) {
            headerSectionMenu.classList.add('header-section--menu-opened');
          }
        }, 100);
      } else {
        headerSectionMenu.classList.remove('header-section--menu-open');
        headerSectionMenu.classList.remove('header-section--menu-opened');
        document.body.classList.remove('menu-open');
      }
    }

    // Close dropdown menus when clicking overlay
    if (menuOverlay) {
        menuOverlay.addEventListener('click', function(e) {
            e.preventDefault();
            headerToggleItems.forEach(i => i.classList.remove('active'));
            updateMenuOpenClass();
        });
    }

    headerItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        // If this item is NOT a toggle, close all menus
        if (!item.classList.contains('header-item--toggle')) {
          headerToggleItems.forEach(i => i.classList.remove('active'));
          updateMenuOpenClass();
        } else {
          // Only change active if this isn't already the active one
          if (!item.classList.contains('active')) {
            headerToggleItems.forEach(i => i.classList.remove('active'));
            item.classList.add('active');
            updateMenuOpenClass();
          }
        }
      });
    });

    if (headerSectionMenu) {
      headerSectionMenu.addEventListener('mouseleave', function(e) {
        setTimeout(() => {
          if (!headerSectionMenu?.matches(':hover')) {
            headerToggleItems.forEach(i => i.classList.remove('active'));
            updateMenuOpenClass();
          }
        }, 10);
      });
    }
});